<template>
    <div>
        <div class="hero hero-sm bg-dark">
            <div class="hero-body container grid-xl">
                <h1>Dungeons and Dragons XR</h1>
                <p>THE place for a DM to manage their tale</p>
            </div>
        </div>
        <div class="container grid-xl">
            <div class="columns mt-2">
                <div class="column mb-2 col-md-12">
                    <div class="card" v-if="game && characters">
                        <div class="card-header">
                            <div class="card-title h5">Live Preview</div>
                            <div class="card-subtitle text-gray">Status of the world</div>
                        </div>
                        <div class="card-body">
                            <div class="divider text-center" data-content="PLAYERS"></div>
                            <div class="tile tile-centered mb-2" v-for="(member, user) in game.connectedMembers">
                                <div class="tile-content">
                                    <div class="tile-title">
                                        <router-link target="_blank" :to="`/players/${member.name}`"> {{member.name}}</router-link>
                                    </div>
                                    <small class="tile-subtitle text-gray">{{user}} · Position: {{vec(member.position)}} · {{characters[member.name].HP}}HP</small>
                                </div>
                                <div class="tile-action">
                                    <button class="btn btn-link">
                                        <i class="icon icon-more-vert"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="divider text-center" data-content="MONSTERS"></div>
                            <div class="tile tile-centered mb-2" v-for="(monster, key) in game.spawnMonster">
                                <div class="tile-content">
                                    <div class="tile-title">{{monster.id[0]}}</div>
                                    <small class="tile-subtitle text-gray">Position: {{vec(monster.pos[0])}}</small>
                                </div>
                                <div class="tile-action">
                                    <button class="btn btn-link" @click="del(key)">
                                        <i class="icon icon-cross"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="loading loading-lg"></div>
                </div>
                <div class="column mb-2 col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title h5">Search for anything</div>
                            <div class="card-subtitle text-gray">Try items, spells, or monsters</div>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <input class="form-input" v-model="search" type="text" placeholder="item name, spell name, etc">
                            </div>
                            <div v-for="(item, i) in filter">
                                {{i+1}}. <router-link target="_blank" :to="`/${item.type}/${item.id}`">{{item.id}}</router-link> <span class="float-right"> {{item.type}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="column mb-2 col-md-12 ">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title h5">Turn Selector</div>
                            <div class="card-subtitle text-gray">As DM, select whose turn it is</div>
                        </div>
                        <div class="card-body">
                            <div class="toast mb-2" :class="{'toast-primary' : v.isTurn}" v-for="(v,k) in members">
                                {{k}}
                                <button class="btn btn-clear icon icon-check float-right" @click="turn(k)"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--<pre v-if="game && characters">
            {{JSON.stringify(game,null,2)}}
            {{JSON.stringify(characters,null,2)}}
        </pre>-->
        </div>
    </div>
</template>
<script>
import Fuse from "fuse.js"
export default {
    name: 'home',
    created() {
        this.rdb.ref('campaigns/ieSevBpTzJys28ySOVnj/connectedMembers').on('value', (snapshot) => {
            this.members = snapshot.val();
        });
        this.rdb.ref('campaigns/ieSevBpTzJys28ySOVnj').on('value', (snapshot) => {
            this.game = snapshot.val();
        });
        this.db.collection("users").doc("spenser").collection("characters").get().then((querySnapshot) => {
            this.characters = {}
            querySnapshot.forEach((doc) => {
                this.characters[doc.id] = doc.data()
            });
        })
    },
    data() {
        return {
            search: "",
            members: null,
            game: null,
            characters: null
        }
    },
    methods: {
        turn(k) {
            Object.keys(this.members).forEach((key) => {
                if (!this.members[key].isDM) this.members[key].isTurn = false
            });
            this.members[k].isTurn = true;
            this.rdb.ref('campaigns/ieSevBpTzJys28ySOVnj/connectedMembers').update(this.members)
        },
        vec(str) {
            var arr = str.split(",")
            var arr2 = []
            for (var i = 0; i < arr.length; i++) {
                arr2.push(Math.round(parseFloat(arr[i].substring(2))))
            }
            return arr2
        },
        del(id) {
            this.rdb.ref("campaigns/ieSevBpTzJys28ySOVnj/spawnMonster").child(id).remove()
        }
    },
    computed: {
        filter() {
            var options = {
                keys: ['id', 'type']
            }
            var fuse = new Fuse(this.$root.list, options)
            return fuse.search(this.search).slice(0, 10)
        }
    }
}
</script>